import { createSlice } from '@reduxjs/toolkit';
import { userDataInitialState } from '../initialStates/userData';

const setUserData = (state, action) => {
  const user = action.payload;

  state.email = user.swissPayload.ldapInfo.email;
  state.idsid = user.swissPayload.realRemoteUser;
  state.wwid = user.swissPayload.ldapInfo.wwid;
  const name = user.swissPayload.ldapInfo.fullName.split(', ');
  state.firstName = name[1];
  state.lastName = name[0];
};

const userDataSlice = createSlice({
  name: 'userData',
  initialState: userDataInitialState,
  reducers: {
    setUserData,
  },
});

export const userDataActions = userDataSlice.actions;

export default userDataSlice.reducer;
